import { api } from "@/api";
import { UpdateBettingMarketParams, BettingMarketDto } from "@/types/ApiResponses/BettingMarket";

export const updateBettingMarket = async (params: UpdateBettingMarketParams): Promise<BettingMarketDto> => {
  const { id, ...body } = params;
  const res = await api.client.patch(`/betting-markets-new/${id}`, body);
  return res.data;
};
